import h from "trader-hyperscript";
import { Router } from "trader.ts/router";
import { room_rooms } from "../../../sql/classy/tables";
import { roomid } from "../../../sql/classy/types";
import * as style from "../../../styles/style.css.classes";
import { renderClassyPage } from "../../renderclassypage";
import * as routes from "../../routes";
import { needsAdminOrTeacher } from "../../security";
import { classyTsContext } from "../../types";

export function renderRoomListHeader() {
  return (
    <tr>
      <th>{"Lokaal"}</th>
      <th>{"Overzicht"}</th>
    </tr>
  );
}

export function renderRoomListItem(r: { id: roomid; description: string }) {
  return (
    <tr>
      <td>
        <a href={routes.roomeditRoute.link({ roomid: r.id })}>
          <b>{r.description}</b>
        </a>
      </td>
      <td>
        <a
          href={routes.roomplanningRoute.link({
            roomid: r.id,
            date: undefined,
          })}
        >
          {"Planning"}
        </a>
      </td>
    </tr>
  );
}

export function registerRoom_listRoutes(router: Router<classyTsContext>) {
  router.page(
    routes.room_listRoute,
    needsAdminOrTeacher,
    async function (ctx, _, token) {
      const db = ctx.db;
      const title = "Lokalen";

      const rooms = await room_rooms.getAll(db);

      return renderClassyPage(
        ctx,
        token,
        "Rooms",
        <h1>{title}</h1>,
        title,
        <main style="max-width: 1280px;">
          {rooms.length === 0 ? (
            <div style="text-align: center">
              <a href={routes.roomeditRoute.link({ roomid: undefined })}>
                {"Je hebt nog geen lokalen aangemaakt. Klik hier om je eerste lokaal in te geven."}
              </a>
            </div>
          ) : (
            <div>
              <div style="text-align: right;margin-bottom: 8px;">
                <a href={routes.roomeditRoute.link({ roomid: undefined })}>
                  <button className={style.button_accent}>
                    {"+ " + "Nieuw lokaal"}
                  </button>
                </a>
              </div>
              <table>
                {renderRoomListHeader()}
                {rooms.orderBy((r) => r.description).map(renderRoomListItem)}
              </table>
            </div>
          )}
        </main>,
      );
    },
  );
}
